import { render } from "./NewSeed.vue?vue&type=template&id=2bb3d0a2"
import script from "./NewSeed.vue?vue&type=script&lang=ts"
export * from "./NewSeed.vue?vue&type=script&lang=ts"

import "./NewSeed.vue?vue&type=style&index=0&id=2bb3d0a2&lang=css"
script.render = render

export default script